import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import ErrorBoundary from './components/ErrorBoundary'

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary
      fallback={
        <div style={{ padding: 40, fontFamily: 'Montserrat, sans-serif', textAlign: 'center' }}>
          <h1>Что-то пошло не так</h1>
          <p>Обновите страницу</p>
          <button style={{ marginTop: 16, padding: '10px 24px', fontSize: 16 }} onClick={() => window.location.reload()}>
            Обновить
          </button>
        </div>
      }
    >
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root')
)

serviceWorker.unregister()
